import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import "./header.css"
import { Link, useParams } from "react-router-dom";
const Header = ({ t, changeLang, language, changeLangMenu }) => {
    const activeheadMenu = () => {
        const headmenu = document.querySelector(".head-2-menu");
        headmenu.classList.toggle("active");
    };

    useEffect(() => {
        const headmenu = document.querySelector(".head-2-menu");

        const handleClick = (e) => {
            if (e.target.classList.contains("head-2-menu")) {
                headmenu.classList.remove("active");
            }
        };

        window.addEventListener("click", handleClick);

        return () => {
            window.removeEventListener("click", handleClick);
        };
    }, []);
    return (
        <>
            <header className="header">
                <div className="container">
                    <div className="header-flex">
                        <div className="head-1 ">
                            <Link className="link" to={"/"} onClick={() => { }}>
                                <img className="head-1-img-logo1" src="/logo_black.png" alt="" />
                                <img className="head-1-img-logo2" src="/logo_white.png" alt="" />
                            </Link>
                        </div>
                        <div className="head-2-menu">
                            <ul>
                                <div className="head-1">
                                    <Link className="link" to={"/"} onClick={() => { activeheadMenu() }}>
                                        <img src="/logo_black.png" alt="" />
                                    </Link>
                                </div>
                                <Link className="link" to={"/"} onClick={() => { activeheadMenu() }}>
                                    <i class="fa fa-home" aria-hidden="true"></i>
                                    <li>{t('maintext1')}</li>
                                </Link>
                                <Link className="link" to={"/tours"} onClick={() => { activeheadMenu() }}>
                                    <i class="fa fa-globe" aria-hidden="true"></i>

                                    <li>{t('maintext2')}</li>
                                </Link>
                                <Link className="link" to={"/gallery"} onClick={() => { activeheadMenu() }}>
                                    <i class="fa fa-picture-o" aria-hidden="true"></i>

                                    <li>{t('maintext3')}</li>
                                </Link>
                                <Link className="link" to={"/about"} onClick={() => { activeheadMenu() }}>
                                    <i class="fa fa-users" aria-hidden="true"></i>

                                    <li>{t('maintext4')}</li>
                                </Link>
                                <Link className="link" to={"/contact"} onClick={() => { activeheadMenu() }}>
                                    <i class="fa fa-phone-square" aria-hidden="true"></i>

                                    <li>{t('maintext5')}</li>
                                </Link>
                                <Link className="link" to={"/support"} onClick={() => { activeheadMenu() }}>
                                    <i class="fa fa-comments-o" aria-hidden="true"></i>
                                    <li>{t('btn-question')}</li>
                                </Link>

                            </ul>
                        </div>
                        <div className="head-2 ">
                            <ul>
                                <Link className="link" to={"/"} onClick={() => { }}>
                                    <li>{t('maintext1')}</li>
                                </Link>
                                <Link className="link" to={"/tours"} onClick={() => { }}>
                                    <li>{t('maintext2')}</li>
                                </Link>
                                <Link className="link" to={"/gallery"} onClick={() => { }}>
                                    <li>{t('maintext3')}</li>
                                </Link>
                                <Link className="link" to={"/about"} onClick={() => { }}>
                                    <li>{t('maintext4')}</li>
                                </Link>
                                <Link className="link" to={"/contact"} onClick={() => { }}>
                                    <li>{t('maintext5')}</li>
                                </Link>
                            </ul>
                        </div>
                        <div className="head-3 ">
                            <ul>
                                <li>
                                    <Link className="link head-3-btn" to={"/support"} onClick={() => { }}>
                                        {t('btn-question')}
                                    </Link>
                                </li>
                                <li>
                                    <span onClick={() => { changeLangMenu() }} className="head-3-btn-change">
                                        {/* {t(`${language === "eng" ? "ENG" : language === "rus" ? "РУС" : "РУС"}`)} */}
                                        {t(
                                            language === "eng"
                                                ? "ENG"
                                                : language === "rus"
                                                    ? "РУС"
                                                    : language === "itl"
                                                        ? "ITL"
                                                        : "РУС"
                                        )}
                                        <i className="fa fa-angle-down" aria-hidden="true"></i>
                                    </span>
                                    <span className="head-3-btn-menu">
                                        <Link onClick={() => { changeLang("eng") }} to={"/"} className="menu-btns link">
                                            ENG
                                            <span>
                                                <img src="/eng.png" alt="" />
                                            </span>
                                        </Link>
                                        <Link onClick={() => { changeLang("rus") }} to={"/"} className="menu-btns link">
                                            РУС
                                            <span>
                                                <img src="/rus.png" alt="" />
                                            </span>
                                        </Link>
                                        <Link onClick={() => { changeLang("itl") }} to={"/"} className="menu-btns link">
                                            ITL
                                            <span>
                                                <img src="/itl.png" alt="" />
                                            </span>
                                        </Link>
                                    </span>
                                </li>
                                <li>
                                    <button className="headbtnopen" onClick={activeheadMenu}>
                                        <i className="fa fa-bars" aria-hidden="true"></i>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}
export default Header